import { TFunctionNonStrict } from 'i18next';
import { Column } from 'react-table';
import { TableCell, TableHeader } from 'redesign';

export const getDepartmentsColumnDefinition = (
  t: TFunctionNonStrict<'ogp-screen-specific', undefined>
): Record<'name', Column<{ name: string }>> => {
  return {
    name: {
      accessor: 'name',
      Header: (
        <TableHeader>
          {t('flexpools.departments.table_headers.department_name', { ns: 'ogp-screen-specific' })}
        </TableHeader>
      ),
      Cell: ({ value }) => <TableCell>{value}</TableCell>,
    },
  };
};
